import { render, staticRenderFns } from "./BulkAssignModal.vue?vue&type=template&id=086d1492&scoped=true&"
import script from "./BulkAssignModal.vue?vue&type=script&lang=js&"
export * from "./BulkAssignModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./BulkAssignModal.vue?vue&type=style&index=1&id=086d1492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d1492",
  null
  
)

export default component.exports